// extracted by mini-css-extract-plugin
module.exports = {"ticket-container":"TicketScanner_ticket-container__sHI3k","ticket-header":"TicketScanner_ticket-header__r0e2x"};